<template>
  <router-view />
</template>

<script setup lang="ts">
// 根组件 — 仅承载路由出口
</script>
